module.exports = __webpack_public_path__ + "static/media/kitchen_transparent.6096a517.png";